import axios, { AxiosRequestConfig } from "axios";
import error from "./error";
import inquery from "./inquery";
import video from "./video";
import trouble from "./trouble";
import param from "./param";
import code from "./code";
import place from "./place";
import product from "./product";
import values from "../values";
import user from "./user";
import { T_appState } from "../../contexts/appState";
import hand from "./hand";
import common from "./common";
import board from "./board";

export function initApis() {

  axios.defaults.baseURL = values.server.url
// //  axios.defaults.baseURL = "localhost:4001";
   axios.defaults.withCredentials = true;
   const raw =  localStorage.getItem("appState");
//   console.log("sett:",raw)

  let appState: T_appState;
      if (raw) {
        try {
          appState = JSON.parse(raw) as T_appState;
          const accessToken = appState.user?.accessToken;    
          axios.defaults.headers.common["Token"] = accessToken;
          console.log("sett:",accessToken)
            } catch (e) {
        }
      } 
  }

  export function initApis11() {
  axios.defaults.baseURL = values.server.url
  }
  export function initApis2(appState1:T_appState) {

    axios.defaults.baseURL = values.server.url
  //  axios.defaults.baseURL = "localhost:4001";
    axios.defaults.withCredentials = true;
 
            const accessToken = appState1.user?.accessToken;    
            axios.defaults.headers.common["Token"] = accessToken;
            console.log("sett:",accessToken)
    }  


  export type T_sendApiConfig = {
    method: "get" | "put" | "post" | "delete";
    url: string;
    data?: any;
    isForm?: boolean;
  };
  
  export type T_responseCommon ={
    msg?:string,
    message?:string,
    isSuccess: boolean;
    code?:string,
    data?:any,
  }

  export async function sendApi(config: T_sendApiConfig) {
   try{
    console.log("config:",config)
    if (config.isForm) {
      const formData = new FormData();
      
      for (const key in config.data) {
        if(key=="filelist"){
          for (const file of config.data[key]) {
            formData.append('files', file);
          }

        }else if(key=="upfiles"){
           config.data["upfiles"].forEach((item:any,i:number) => {
              
                if (item.id !== undefined) {
                    console.log("append:",key+":"+ item.id);
                    formData.append(`upfiles[${i}].id`, item.id.toString());
                  }
                  formData.append(`upfiles[${i}].sort`, item.sort.toString());
                  if (item.file) {
                    // MultipartFile로 매핑될 부분
                    formData.append(`upfiles[${i}].file`, item.file);
                  }
           });
        }     
        else{
          
         formData.append(key, config.data[key]);
        }
      }

 
      
      const axiosConfig: AxiosRequestConfig = {
        method: config.method,
        data: formData,
        url : config.url,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

             
      const response = await axios(axiosConfig);
      console.log("response:",response)
      const data = response.data;
      data.msg = data?.message || "";
         const newData: T_responseCommon = data;
        return newData
    }else{
      console.log("axios status:",axios.defaults)
      const response = await axios(config);
      console.log("response:",response)
      const data = response.data;
      data.msg = data?.message || "";
         const newData: T_responseCommon = data;
        return newData
    }

  }catch (error: any) {
    if (error.response && error.response.status === 401) {
      // 401 에러가 발생하면 전역 로그아웃 함수를 호출합니다.
      console.log("error:",error)
      if ((window as any).__GLOBAL_LOGOUT__) {
        (window as any).__GLOBAL_LOGOUT__();
      }
    }
    throw error;
  }
  
  }

  
const apis = {
  error,
  inquery,
  video,
  trouble,
  param,
  code,
  place,
  product,
  user,
  hand,
  common,
  board,
};

export default apis;
